// extracted by mini-css-extract-plugin
export default {"wrapper":"DataMonitoringAlarmRecords_wrapper__fiwGi","tabStyles":"DataMonitoringAlarmRecords_tabStyles__oqYnT","dateSwitch":"DataMonitoringAlarmRecords_dateSwitch__LajYX"};